import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@emotion/react';
import { tokens } from '../theme';
import { Box, TextField } from '@mui/material';
import { Formik } from 'formik';
import * as yup from "yup";
import { toast, Toaster } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { addProject } from '../redux/actions';




export default function AddProjectModal({ open, onClose, onSubmit, newProjectId }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [scroll, setScroll] = React.useState('paper');

    const checkoutSchema = yup.object().shape({
        fy: yup.string().required("required"),
        client_name: yup.string().required("required"),
        cp_name: yup.string().required("required"),
        state: yup.string().required("required"),
        capex_opex: yup.string().required("required"),
        bd_owner: yup.string().required("required"),
        credit_rating: yup.string().required("required"),
        dc_capacity_mwp: yup.number().required("required"),
        status: yup.string().required("required"),
        remarks: yup.string().required("required"),
    });

    const initialValues = {
        id: newProjectId,
        fy: '',
        client_name: '',
        cp_name: '',
        state: '',
        type_of_project: '',
        capex_opex: '',
        bd_owner: '',
        credit_rating: '',
        dc_capacity_mwp: '',
        ppa_tariff: '',
        status: '',
        weeks_loa_expected: '',
        loa_expected_by: '',
        remarks: '',
        last_connected: '',
        offer_submitted_on: '',
        procurement_process: '',
        ac_capacity_mw: '',
        ppa_rs_kwh_15_yrs: '',
        ppa_rs_kwh_20_yrs: '',
        offer_no: ''
    };
    const dispatch = useDispatch();
    const handleFormSubmit = (values) => {
        toast.success(`Project ${values.id} Added Successfully!`);
        console.log(values);
        dispatch(addProject(values))
        setTimeout(() => {
            onClose();
        }, 2000)
    };

    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick")
            return;
        onClose();
    }
    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);
    const handleBackdropClick = (event) => {
        event.stopPropagation();
        return false;
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            fullWidth
            PaperProps={{ style: { backgroundColor: colors.primary[900] } }}
        >

            <DialogTitle id="scroll-dialog-title">Add Project</DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>
                <Box m="20px">

                    <Formik
                        onSubmit={handleFormSubmit}
                        initialValues={initialValues}
                        validationSchema={checkoutSchema}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box
                                >
                                    <TextField
                                        disabled
                                        fullWidth
                                        variant="filled"
                                        label="ID"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.id}
                                        name="id"
                                        margin='normal'
                                        InputProps={{ disableUnderline: true }}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Financial year"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.fy}
                                        name="fy"
                                        margin='normal'
                                        error={!!touched.fy && !!errors.fy}
                                        helperText={touched.fy && errors.fy}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Cient Name"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.client_name}
                                        name="client_name"
                                        margin='normal'
                                        error={!!touched.client_name && !!errors.client_name}
                                        helperText={touched.client_name && errors.client_name}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="CP Name"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.cp_name}
                                        name="cp_name"
                                        margin='normal'
                                        error={!!touched.cp_name && !!errors.cp_name}
                                        helperText={touched.cp_name && errors.cp_name}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="State"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.state}
                                        name="state"
                                        margin='normal'
                                        error={!!touched.state && !!errors.state}
                                        helperText={touched.state && errors.state}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="CAPEX/OPEX"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.capex_opex}
                                        name="capex_opex"
                                        margin='normal'
                                        error={!!touched.capex_opex && !!errors.capex_opex}
                                        helperText={touched.capex_opex && errors.capex_opex}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="BD Owner"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.bd_owner}
                                        name="bd_owner"
                                        margin='normal'
                                        error={!!touched.bd_owner && !!errors.bd_owner}
                                        helperText={touched.bd_owner && errors.bd_owner}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Credit Rating"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.credit_rating}
                                        name="credit_rating"
                                        margin='normal'
                                        error={!!touched.credit_rating && !!errors.credit_rating}
                                        helperText={touched.credit_rating && errors.credit_rating}
                                    />

                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="DC Capacity(MWp)"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.dc_capacity_mwp}
                                        name="dc_capacity_mwp"
                                        margin='normal'
                                        error={!!touched.dc_capacity_mwp && !!errors.dc_capacity_mwp}
                                        helperText={touched.dc_capacity_mwp && errors.dc_capacity_mwp}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Status"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.status}
                                        name="status"
                                        margin='normal'
                                        error={!!touched.status && !!errors.status}
                                        helperText={touched.status && errors.status}
                                    />
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Remarks"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.remarks}
                                        name="remarks"
                                        margin='normal'
                                        error={!!touched.remarks && !!errors.remarks}
                                        helperText={touched.remarks && errors.remarks}
                                    />
                                </Box>

                                <Box display="flex" justifyContent="center" mt="20px">
                                    <Button onClick={handleClose} variant="contained" size='large'

                                        sx={{
                                            marginRight: "10px",
                                            backgroundColor: colors.grey[100],
                                            color: colors.grey[900],
                                            ":hover": {
                                                backgroundColor: colors.grey[200],
                                                color: colors.grey[800]
                                            }
                                        }}
                                    >
                                        Close
                                    </Button>
                                    <Button type="submit" color="secondary" variant="contained" size='large' >
                                        Add New Project
                                    </Button>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Box>
            </DialogContent>
            <Toaster />
        </Dialog>
    );
}

